"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
const episourceColor = {
  main: '#883907',
  light: '#A2A4F3',
  dark: '#0B00AF',
  primaryMain: '#883907',
  primaryLight: '#A2A4F3',
  primaryDark: '#0B00AF',
  secondaryMain: '#3E567A',
  secondaryLight: '#6C82A9',
  secondaryDark: '#0E2D4E',
  textPrimary: 'rgba(0,0,0,87%)',
  textSecondary: 'rgba(0,0,0,60%)',
  textDisabled: 'rgba(0,0,0,38%)',
  textContrast: '#FFFFFF',
  iconDefault: 'rgba(0, 0, 0, 0.60)',
  iconHover: 'rgba(0, 0, 0, 0.87)',
  divider: 'rgba(0, 0, 0, 0.12)',
  backgroundDefault: '#FBFBFF',
  backgroundPaper: '#FFFFFF',
  epiEncounter: '#4A148C',
  epiCoder: '#1F2B7D',
  epiAnalystLegacy: '#122937',
  epiAnalystBackground: '#F9F8F6',
  epiAnalystBackgroundLight: '#F8F6F4',
  epiAnalystPrimaryDark: '#570A00',
  epiAnalystPrimaryMarkerting: '#F47321',
  epiEngage: '#656CCD',
  epiDXSearch: '#F9F9FE',
  epiGeneral: '#3E567A',
  epiSAAS: '#F6F6FD',
  buttonDefault: '#4449bd',
  buttonHover: '#883907',
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
var _default = episourceColor; // export default episourceColor;
exports["default"] = _default;